import ApiUrls from "services/ApiUrl";
import BaseService from "services/Base";
import { Master } from "types/common/master";

export default class ContentService extends BaseService {

    async getAllContentServices(param: Master.BodyParamType = {}) {
      try {
        const response = await this.post(`${ApiUrls.contentService}/list`, param);
        return response?.data;
      } catch (error) {
        throw error;
      }
    }
}